import React from "react";

import "./ForgotPassword.css";
import { Button, Col, notification } from "antd";
import { TextField } from "@material-ui/core";
import { useState } from "react";
// import { FormControl, IconButton, InputAdornment } from "@mui/material";
// import Visibility from "@mui/icons-material/Visibility";
// import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { BACKEND_URL } from "../../config/config";
import axios from "axios";

export default function ForgotPassword({ setIsVisibleModal, isVisibleModal }) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  const getErrorMessage = (error) => {
    if (error?.response?.data?.message) {
      return error.response.data.message;
    }

    if (error?.message) {
      return error.message;
    }

    return "We could not process your password reset request. Please try again later.";
  };

  const forgotPassword = async () => {
    if (loading) {
      return;
    }

    const email = String(data.email || "").trim();

    if (!email) {
      notification["error"]({
        message:
          "Please enter your email address before submitting the request",
      });
      return;
    }

    setLoading(true);

    try {
      const url = `${BACKEND_URL}/customers/forgotPassword`;

      const dataSendApi = {
        email,
      };

      const response = await axios.post(url, dataSendApi);

      if (response?.data?.code === 0) {
        notification["success"]({
          message:
            response.data.message ||
            "Password reset instructions were sent to your email address.",
        });
        setData({});
        setIsVisibleModal(false);
        return;
      }

      notification["error"]({
        message:
          response?.data?.message ||
          "We could not process your password reset request.",
      });
    } catch (e) {
      console.log("error catch forgotPassword", e);
      notification["error"]({
        message: getErrorMessage(e),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          marginTop: "1rem",
        }}
      >
        <Col span={24}>
          <div style={{ paddingBottom: "1.5rem" }}>
            Please enter the email address associated with your account. We will
            send you instructions on how to reset your password.
          </div>
          <TextField
            id="standard-basic"
            label="Email"
            variant="outlined"
            fullWidth
            required
            size="small"
            value={data?.email}
            onChange={(e) => setData({ ...data, email: e.target.value })}
          />
        </Col>
      </div>

      {/* <Row gutter={24} className="marginTop">
        <Col span={24}>
          <FormControl
            fullWidth
            variant="outlined"
            size="small"
            onChange={(e) => setData({ ...data, password: e.target.value })}
            required
          >
            <InputLabel htmlFor="outlined-adornment-password">
              New password
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showPassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Password"
            />
          </FormControl>
        </Col>
      </Row>

      <Row gutter={24} className="marginTop">
        <Col span={24}>
          <FormControl
            fullWidth
            variant="outlined"
            size="small"
            onChange={(e) =>
              setData({ ...data, repeatPassword: e.target.value })
            }
            required
          >
            <InputLabel htmlFor="outlined-adornment-password">
              Repeat Password
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showRepeatPassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowRepeatPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showRepeatPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Password"
            />
          </FormControl>
        </Col>
      </Row> */}

      <div className="containerLoginButton">
        <Button
          className="login-form__button"
          loading={loading}
          onClick={forgotPassword}
        >
          Reset Request
        </Button>
      </div>
    </>
  );
}
